// extracted by mini-css-extract-plugin
export default {"unauthTitle":"Unauthorized_unauthTitle__HHIla","unauthHeader":"Unauthorized_unauthHeader__ncG+F","landingpage":"Unauthorized_landingpage__yelPw"};